export default function InputPspResponsible() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            model: "=",
            validation: "=",
            label: "=",
        },
        template: require("./template.html"),
        controller: function ($scope) {},
    };
}
